import httpClient from "@/services/httpClient";
import { server } from "@/services/constants";

export const getdataByIdim_principal = (id) => {
  return httpClient.get(server.IM_PRINCIPAL + `/getbyid/${id}`);
};

export const getAllim_principal_Company = (query) => {
  return httpClient.get(
    server.IM_PRINCIPAL + `/getAllim_principal_Company`,
    query
  );
};

export const getAllim_principal_CompanyPagination = (
  company_id,
  pageNum,
  limitNum,
  sortBy,
  sortOrderUpper
) => {
  return httpClient.get(
    server.IM_PRINCIPAL + `/getAllim_principal_CompanyPagination`,
    {
      params: {
        company_id: company_id,
        page: pageNum,
        limit: limitNum,
        sortBy: sortBy,
        sortOrder: sortOrderUpper,
      },
    }
  );
};

export const getAllim_principal_CompanyPaginationV2 = (
  company_id,
  pageNum,
  limitNum,
  sortBy,
  sortOrderUpper,
  search
) => {
  // console.log(`param:  company_id ${company_id}`);
  // console.log(`param:  pageNum ${pageNum}`);
  // console.log(`param:  limitNum ${limitNum}`);
  // console.log(`param:  sortBy ${sortBy}`);
  // console.log(`param:  sortOrderUpper ${sortOrderUpper}`);
  // console.log(`param:  search ${search}`);

  return httpClient.get(
    server.IM_PRINCIPAL + `/getAllim_principal_CompanyPaginationV2`,
    {
      params: {
        company_id: company_id,
        page: pageNum,
        limit: limitNum,
        sortBy: sortBy,
        sortOrder: sortOrderUpper,
        search: search,
      },
    }
  );
};

export const getfile_numberim_principal_Company = (query) => {
  return httpClient.get(
    server.IM_PRINCIPAL + `/getfile_numberim_principal_Company`,
    query
  );
};

export const addim_principal = (data) => {
  return httpClient.post(server.IM_PRINCIPAL + `/`, data);
};

export const updateim_principal = (id, data) => {
  return httpClient.put(server.IM_PRINCIPAL + `/${id}`, data);
};
export const updateim_principal_nofile = (id, data) => {
  return httpClient.put(server.IM_PRINCIPAL + `/updateNofile/${id}`, data);
};

export const deleteim_principal = (id) => {
  return httpClient.delete(server.IM_PRINCIPAL + `/${id}`);
};
